import { UsersThree } from "@phosphor-icons/react";
import { StatGrid } from "./StatGrid";
import { EmptyState } from "../shared/EmptyState";

export const PitcherCard = ({ label, pitcher, block, testId }) => {
  const derived = block?.derived || {};
  const available = block?.status === "available";
  return (
    <div data-testid={testId} className="flex flex-col gap-3 rounded-lg border border-white/10 bg-eb-surface p-4">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">{label}</span>
        <span className="font-mono text-[10px] uppercase text-zinc-500">
          {pitcher?.throws ? `Throws ${pitcher.throws}` : "Handedness Unavailable"}
        </span>
      </div>
      <p data-testid={`${testId}-name`} className="font-heading text-lg text-white">
        {pitcher?.full_name || "Not Confirmed"}
      </p>
      {available ? (
        <StatGrid
          testIdPrefix={testId}
          stats={[
            { label: "ERA", value: derived.era },
            { label: "WHIP", value: derived.whip },
            { label: "FIP", value: derived.fip },
            { label: "IP", value: derived.innings_pitched },
            { label: "K/9", value: derived.strikeout_rate_per9 },
            { label: "BB/9", value: derived.walk_rate_per9 },
            { label: "HR/9", value: derived.hr_rate_per9 },
            { label: "K-BB%", value: derived.k_minus_bb_pct != null ? `${derived.k_minus_bb_pct}%` : null },
            { label: "GS", value: derived.games_started },
            { label: "W-L", value: derived.games_started != null ? `${derived.wins}-${derived.losses}` : null },
            { label: "Recent Starts", value: null },
          ]}
        />
      ) : (
        <EmptyState icon={UsersThree} title="Statistics Unavailable" description={block?.reason} testId={`${testId}-empty`} />
      )}
    </div>
  );
};
